import { render } from "./SubSupervisors.vue?vue&type=template&id=38467bba"
import script from "./SubSupervisors.vue?vue&type=script&lang=js"
export * from "./SubSupervisors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__